import { render, staticRenderFns } from "./ReplyPanelIcon.vue?vue&type=template&id=7ed34a52&"
import script from "./ReplyPanelIcon.vue?vue&type=script&lang=js&"
export * from "./ReplyPanelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports